(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slider-section"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('#image-slider-section .swiper-container', {
  slidesPerView: 2.5,
  spaceBetween: 10,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 4.5,
      spaceBetween: 20,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel-section"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('#review-carousel .swiper-container', {
  slidesPerView: 1.3,
  spaceBetween: 10,
  centeredSlides: true,
  loop:true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {

     768: { // Mobile view
      slidesPerView: 3, // Show 1 slide in the center and 2 partially on the sides
      
      spaceBetween: 30,
      loop:true,
    }
  }
});


  } catch(e) { console.error(e); }
})();
})();
